import { Paper, Typography } from '@mui/material';
import { FC } from 'react';


const Error: FC = () => {
    return (
        <>
            <Typography variant="h1" gutterBottom>
                Error
            </Typography>
            <Paper>
                Error
            </Paper>
        </>
    );
}

export default Error;